var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-header-title"},[_c('AtomLogoMascaron',{attrs:{"clase":"logoHeader"}}),_c('h1',[_vm._v("Ley de Consulta a los Pueblos Indígenas y Afroamericanos")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }